
( ( $ ) => {

	phr_infinite_scroll_trigger = () => {
		const facet_wrapper = $( '.facetwp-facet-infinite_scroll' );

		if ( ! facet_wrapper.length || facet_wrapper.hasClass( 'is-loading' ) )
		{
			return;
		}

		const facet_top			= parseInt( facet_wrapper.offset().top );
		const viewport_top		= $( window ).scrollTop();
		const viewport_height	= $( window ).height();
		const viewport_begin	= parseInt( viewport_top + viewport_height );
		const facet_button		= facet_wrapper.find( '.facetwp-load-more' );

		if ( ! facet_button )
		{
			return;
		}

		if ( viewport_begin >= facet_top )
		{
			facet_button.trigger( 'click' );
		}
	}

	$( window ).on( 'resize scroll', phr_infinite_scroll_trigger );

} )( jQuery );

 